/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import Breadcrumbs from '@/components/AZCustomComponent/BreadcrumbSTARC';
import { useLocationBreadcrumbsData } from '../../hooks/useLocationBreadcrumbsData';
import type { LocationsPageType } from '../../interface/types';
import styles from './LocationsBreadcrumbs.module.scss';
import cx from 'classnames';

type LocationsBreadcrumbsProps = {
  pageType: LocationsPageType;
  noVerticalMargin?: boolean;
  noHorizontalMargin?: boolean;
};

export function LocationsBreadcrumbs({
  pageType,
  noHorizontalMargin = false,
  noVerticalMargin = false,
}: LocationsBreadcrumbsProps) {
  const breadcrumbData = useLocationBreadcrumbsData({ pageType });

  return (
    <Breadcrumbs
      customClass={cx(
        styles.locationsBreadcrumbs,
        noHorizontalMargin && styles.noHorizontalMargin,
        noVerticalMargin && styles.noVerticalMargin,
      )}
      data={breadcrumbData}
      lastItemDisabled={true}
      originalDesign
      classNames={{
        nav: styles.breadcrumbNav,
        item: styles.breadcrumbItem,
        separator: styles.breadcrumbSeparator,
      }}
    />
  );
}
